import { ApiMatchEventIdGet200ResponseDataMatchStatisticsTotalsCompetitorsInnerPlayersInner } from '@/api/livescore/generated';

export const calculatePlayerRating = (
  position: string,
  stats: ApiMatchEventIdGet200ResponseDataMatchStatisticsTotalsCompetitorsInnerPlayersInner['statistics'],
) => {
  if (stats?.minutes_played && stats?.minutes_played < 15) {
    return 6.0;
  }

  const per90Factor = stats?.minutes_played && stats?.minutes_played > 0 ? 90 / stats?.minutes_played : 1;

  let score = 6.5;

  score -= (stats?.own_goals ?? 0) * 2.0;
  score -= (stats?.yellow_cards ?? 0) * 0.3;

  score += (stats?.goals_scored ?? 0) * per90Factor * 1.2;
  score += (stats?.assists ?? 0) * per90Factor * 0.8;
  score -= (stats?.fouls_committed ?? 0) * per90Factor * 0.05;
  score += (stats?.was_fouled ?? 0) * per90Factor * 0.05;
  score -= (stats?.loss_of_possession ?? 0) * per90Factor * 0.05;

  const passAccuracy =
    (stats?.passes_total ?? 0) > 0 ? (stats?.passes_successful ?? 0) / (stats?.passes_total ?? 0) : 0;
  if (passAccuracy > 0) {
    score += (passAccuracy - 0.75) * 1.5;
  }

  switch (position.toLowerCase()) {
    case 'goalkeeper':
      score += (stats?.shots_faced_saved ?? 0) * 0.2;
      score += (stats?.diving_saves ?? 0) * 0.25;
      score += (stats?.penalties_saved ?? 0) * 1.0;
      score -= (stats?.goals_conceded ?? 0) * 0.4;
      if ((stats?.goals_conceded ?? 0) === 0 && (stats?.minutes_played ?? 0) > 60) score += 0.8;
      break;

    case 'defender':
      score -= (stats?.goals_conceded ?? 0) * 0.1;
      score += (stats?.tackles_successful ?? 0) * per90Factor * 0.25;
      score += (stats?.interceptions ?? 0) * per90Factor * 0.2;
      score += (stats?.clearances ?? 0) * per90Factor * 0.1;
      score += (stats?.defensive_blocks ?? 0) * per90Factor * 0.15;
      if ((stats?.goals_conceded ?? 0) === 0 && (stats?.minutes_played ?? 0) > 60) {
        score += 0.5;
      }
      break;

    case 'midfielder':
      score += (stats?.chances_created ?? 0) * per90Factor * 0.3;
      score += (stats?.dribbles_completed ?? 0) * per90Factor * 0.2;
      score += (stats?.tackles_successful ?? 0) * per90Factor * 0.1;
      score += (stats?.interceptions ?? 0) * per90Factor * 0.1;
      const longPassAccuracy =
        (stats?.long_passes_total ?? 0) > 0
          ? (stats?.long_passes_successful ?? 0) / (stats?.long_passes_total ?? 0)
          : 0;
      score += longPassAccuracy * 0.3;
      break;

    case 'forward':
      score += (stats?.shots_on_target ?? 0) * per90Factor * 0.2;
      score -= (stats?.shots_off_target ?? 0) * per90Factor * 0.1;
      score += (stats?.chances_created ?? 0) * per90Factor * 0.4;
      score += (stats?.dribbles_completed ?? 0) * per90Factor * 0.3;
      score -= (stats?.offsides ?? 0) * per90Factor * 0.1;
      break;

    default:
      score += (stats?.chances_created ?? 0) * per90Factor * 0.2;
      score += (stats?.dribbles_completed ?? 0) * per90Factor * 0.15;
      break;
  }

  let finalRating = score;
  finalRating = Math.max(3.0, finalRating);
  finalRating = Math.min(10.0, finalRating);

  if ((stats?.red_cards ?? 0) > 0 || (stats?.yellow_red_cards ?? 0) > 0) {
    finalRating = Math.min(finalRating, 5.0);
  }

  return parseFloat(finalRating.toFixed(1));
};
